import React, {useState} from 'react';
import {Button, Card, Input, message, Row, Space, Steps} from 'antd';
import {Auth} from "@aws-amplify/auth";
import {useNavigate, useLocation} from "react-router";
import queryString from 'query-string';

const {Step} = Steps;

const constantTimeEquals = (a, b) => {
    if (a.length !== b.length) return false;
    let result = 0;
    for (let i = 0; i < a.length; i++) {
        result |= a.charCodeAt(i) ^ b.charCodeAt(i);
    }
    return result === 0;
};

const ResetPasswordPublic = (props) => {
    const location = useLocation();
    const params = queryString.parse(location.search);
    const username = params.username;
    const [email, setEmail] = useState(username ? username : "");
    const [tempPassword, setTempPassword] = useState( "");
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [currentStep, setCurrentStep] = useState(0);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
   
    const handleOk = () => {
        if (currentStep === 0) {
            if (email === '' || tempPassword === '') {
                message.warning("Please enter email and your temporary password!");
            } else {
                Auth.signIn(email, tempPassword)
                    .then(user => {
                        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                            setCurrentStep(1);
                            setUser(user);
                        } else {
                            message.error("Something went wrong at our end.");
                        }
                    }).catch(e => {
                    message.error(e.message);
                });
            }
        } else if (currentStep === 1) {
            const isPasswordEmpty = !password;
            const isConfirmPasswordEmpty = confirmPassword.length === 0;
            if (isPasswordEmpty || isConfirmPasswordEmpty || (!constantTimeEquals(password, confirmPassword))) {
                message.warning("Passwords don't match!");
            } else {
                Auth.completeNewPassword(user, password).then(user => {
                    Auth.signOut();
                    navigate("/login");
                    message.success("Password reset, please sign in again.");
                }).catch(e => {
                    message.error(e.message);
                });
            }
        }
    };

    return (
        <>

            <Row justify="center">
                <div className="content" >
                    <Row justify="center">
                        <img src="/niq-lg-rgb-pos.png" width="500px" alt="Nielsen IQ"/>
                    </Row>
                    <Card bordered={false} style={{width: 600}}>
                        <Steps current={currentStep}>
                            <Step title="Sign in with your temporary password"/>
                            <Step title="Reset Password"/>
                        </Steps>
                        {currentStep === 0 && (
                            <div style={{marginTop: 20}}>
                                <Space direction="vertical" style={{width: '100%'}}>
                                    <Input placeholder="Enter your email" value={email}
                                           onChange={(e) => setEmail(e.target.value)}/>
                                    <Input.Password placeholder="Temporary password" value={tempPassword}
                                                    onChange={(e) => setTempPassword(e.target.value)}/>
                                    <Button type="primary" onClick={handleOk}>OK</Button>
                                </Space>

                            </div>
                        )}
                        {currentStep === 1 && (
                            <div style={{marginTop: 20}}>
                                <Space direction="vertical" style={{width: '100%'}}>
                                    <Space direction="vertical" style={{width: '100%'}}>
                                        <Input.Password placeholder="New Password" value={password}
                                                        onChange={(e) => setPassword(e.target.value)}/>
                                        <Input.Password placeholder="Confirm New Password" value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}/>
                                        <Button type="primary" onClick={handleOk}>Save</Button>
                                    </Space>
                                </Space>

                            </div>
                        )}
                    </Card>
                </div>
                <div className="background-image" style={{backgroundImage: "url('page-header.svg')"}}/>
                <div className="page-footer"/>
            </Row>



        </>
    );
};

export default ResetPasswordPublic;